import React from "react";
import { Slider } from "./styles";
import { motion } from "framer-motion";

const SliderPage = () => {
	return (
		<>
			<Slider>
				<motion.div
					initial={{ scaleX: 0 }}
					animate={{ scaleX: 0 }}
					exit={{ scaleX: 1 }}
					transition={{ duration: 1, ease: "easeInOut" }}
					className='slide-in'
				></motion.div>
				<motion.div
					initial={{ scaleX: 1 }}
					animate={{ scaleX: 0 }}
					exit={{ scaleX: 0 }}
					transition={{ duration: 1, ease: "easeInOut" }}
					className='slide-out'
				></motion.div>
			</Slider>
		</>
	);
};

export default SliderPage;
